import { useEffect, useState } from 'react';
import { CustomRef, SectionId } from '../Navigation';

/*
 * Temporary solution for making sure section is shown in sticky nav
 * Issue occurs when using Bullfinch within Vision as session is not always
 * available at server time
 */
export const useForceSectionInNav = (
  sections: React.MutableRefObject<CustomRef[]>,
  sectionId: SectionId,
  update: boolean
) => {
  const [_, setForceRender] = useState(0);

  useEffect(() => {
    if (update) {
      const isDisplayed = sections.current.find(section => section.id === sectionId)?.display;

      if (!isDisplayed) {
        sections.current = sections.current.map(ref =>
          ref.id === sectionId ? { ...ref, display: true } : ref
        );
        setForceRender(prev => prev + 1);
      }
    }
  }, [update, sections, sectionId]);
};
